import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../../lib';
import dateFormat from "dateformat";
import {dateFormatsLocations} from "../../constants/dateFormatsLocations";
import API from "../../api";



class BranchingOption extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            trigger: false,
        };
        this.triggetNext = this.triggetNext.bind(this);


    }
    componentDidMount() {


        let trigger_value = '';

        try {
        switch (this.props.steps.option.value) {
            case 'BookingApp':
                trigger_value = 'getServices_ask';
                break;
            case 'CancelApp':
                trigger_value = 'ChooseAppForCancel';
                break;
            case 'RescheduleApp':
                trigger_value = 'ChooseAppForReschedule';
                break;
            case 'ShowMyAppointments':
                trigger_value = 'show_my_appointment';
                break;
            default:
                trigger_value = 'say_how_can_help';

        }


        }catch (e) {
            this.setState({
                error: 'Option with id option missed',
                loading: false
            });

            return;
        }




        if (this.props.steps.option.value === 'BookingApp') {
            let self = this;
            let featureAppointments = this.getFutureAppointments().then(function (appointments) {


                if (Array.isArray(appointments) && appointments.length > 0 ) {
                    self.triggetNext(true, self.props.have_appointments_trigger);
                } else {
                    self.triggetNext(true, trigger_value);
                }
            });


        }else{
            this.triggetNext(true, trigger_value);
        }
    }

    triggetNext(value, trigger) {
        this.setState({trigger: true});
        this.props.triggerNextStep({value: value, trigger: trigger})
    }

    getFutureAppointments(){

        const {store} = this.props;
        const {settings} = store;

        dateFormat.i18n = dateFormatsLocations[settings.language];
        const params = {
            patient_id: store.patient.id
        };
      return  API.get('/getFutureAppointments',{params}).then((res) => {
            const result = res.data;
            var appointments = [];

            if (result.status == "success") {
                if(result.data.length>0){
                    result.data.forEach(function (item, i, arr) {
                        let date_arr = item.start.split(/[- :]/),
                        current_date = new Date(date_arr[0], date_arr[1]-1, date_arr[2], date_arr[3], date_arr[4], date_arr[5]);
                        let appData = dateFormat(current_date, "dddd, d mmm HH:MM ");
                        appointments.push({value: item, label: appData +' - '+item.services});
                    });
                    this.setState(
                        {appointments: appointments},
                        ()=>{
                            this.setState(
                                {loading: false}
                            );
                        }
                    );
                }else{
                    this.setState(
                        {loading: false}
                    );
                }
            }
            return appointments;

        }).catch((error) => {
            this.setState({
                error: 'Error retrieving data',
                loading: false
            });
        });
    }

    render() {
        const {loading} = this.state;
        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (

                    ''
                )}
            </div>
        );
    }
}

BranchingOption.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

BranchingOption.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default BranchingOption;
